<template>
  <form
    class="sign-up is-centered"
    @submit.prevent="onSubmit"
  >
    <img
      :src="logo"
      alt="logo"
    >

    <h1 class="title is-4 has-text-primary">
      Registro
    </h1>

    <div class="columns is-multiline">
      <div class="column is-12-mobile is-12-fullhd is-6">
        <AppInputName
          :value="name"
          :disabled="loading"
          :loading="loading"
          :required="true"
          @input="onChange"
          @change="onChange"
        />
      </div>

      <div class="column is-12-mobile is-12-fullhd is-6">
        <AppInputEmail
          :value="email"
          :disabled="loading"
          :loading="loading"
          :required="true"
          @input="onChange"
          @change="onChange"
        />
      </div>

      <div class="column is-12-mobile is-12-fullhd is-6">
        <AppInputPassword
          :value="password"
          :disabled="loading"
          :loading="loading"
          :required="true"
          @input="onChange"
          @change="onChange"
        />
      </div>

      <div class="column is-12-mobile is-12-fullhd is-6">
        <AppInputPassword
          id="passwordConfirmation"
          name="passwordConfirmation"
          label="Repetir Contraseña"
          error-message="Las contraseñas no coinciden"
          :value="passwordConfirmation"
          :pattern="password"
          :loading="loading"
          :disabled="loading"
          :required="true"
          @input="onChange"
          @change="onChange"
        />
      </div>
    </div>

    <ButtonSubmit
      :loading="loading"
      :disabled="loading"
      text="regístrate"
    />

    <LinkSignIn />
    <LinkForgottenPassword />
  </form>
</template>

<script>
import merge from 'lodash/merge';
import { createNamespacedHelpers, mapGetters } from 'vuex';

const { mapState, mapMutations, mapActions } = createNamespacedHelpers('auth');

export default {
  name: 'SignUp',
  components: {
    AppInputName: () => import(/* webpackChunkName: "app-input-name" */ '@/components/AppInputName.vue'),
    AppInputEmail: () => import(/* webpackChunkName: "app-input-email" */ '@/components/AppInputEmail.vue'),
    AppInputPassword: () => import(/* webpackChunkName: "app-input-password" */ '@/components/AppInputPassword.vue'),
    LinkSignIn: () => import(/* webpackChunkName: "auth-link-sign-in" */ '@/components/Auth/LinkSignIn.vue'),
    LinkForgottenPassword: () => import(/* webpackChunkName: "auth-link-forgotten-password" */ '@/components/Auth/LinkForgottenPassword.vue'),
    ButtonSubmit: () => import(/* webpackChunkName: "auth-button-submit" */ '@/components/Auth/ButtonSubmit.vue'),
  },
  data() { return { loading: false }; },
  computed: merge(
    mapState({
      name: ({ name }) => name,
      email: ({ email }) => email,
      password: ({ password }) => password,
      passwordConfirmation: ({ passwordConfirmation }) => passwordConfirmation,
    }),
    mapGetters({ logo: 'ui/authLogo' }),
  ),
  beforeDestroy() { this.cleanSensitiveData(); },
  methods: merge(
    mapMutations(['setValue', 'cleanSensitiveData']),
    mapActions(['signUp', 'initAuthentication']),
    {
      onChange(event) {
        const { name: accessor, value } = event.target;
        this.setValue({ accessor, value });
      },
      async onSubmit() {
        this.loading = true;

        try {
          await this.signUp();

          this.$router.replace({ name: 'VerificationPending' });
        } catch ({ message }) {
          this.$danger({ message });
        }

        this.loading = false;
      },
    },
  ),
};
</script>

<style scoped>
@media screen and (min-width: 769px) {
  form {
    width: 750px;
  }
}
</style>
